import "./App.scss";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomeLayout from "./components/HomeLayout";
import Home from "./pages/Home";
import Features from "./pages/Features";
import ATSFeatures from "./pages/ATSFeatures";
import Pricing from "./pages/Pricing";
import Aboutus from "./pages/Aboutus";
import Resources from "./pages/Resources";
import Blog from "./pages/Blog";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ScrollToTop() {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
}

function App() {
	return (
		<Router>
			<ScrollToTop />
			<HomeLayout>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/features" element={<Features />} />
					<Route path="/features/ats" element={<ATSFeatures/>} />
					<Route path="/pricing" element={<Pricing/>} />
					<Route path="/aboutus" element={<Aboutus/>} />
					<Route path="/resources" element={<Resources/>} />
					<Route path="/blog" element={<Blog/>} />
				</Routes>
			</HomeLayout>
			<ToastContainer />
		</Router>
	);
}

export default App;
